import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    Grid,
    Paper,
    TextField,
    Typography
} from "@mui/material";
import {WebcamCapture} from "../../../management/people/components/WebcamCapture";
import React, {useEffect, useState} from "react";
import {useCommonItems} from "../../../../../contexts/CommonItensProvider";
import {checkUserPassword, resetCredentials} from "../../../management/companies/configs/functions";
import {VerifiedUser, Person, Fingerprint, Info, Warning} from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import {FirstAccess} from "../../../FirstAccess/FirstAccess";
import {ResetCredentials} from "../../../FirstAccess/ResetCredentials";
import {hasPermission} from "../../../../../configs/functions";

export function NewRequisicaoSecondStep({
                                                 selectedPessoa,
                                                 biometriaSrc,
                                                 setBiometriaSrc,
                                                 isAllowedCapture,
                                                 setIsAllowedCapture,
                                                 isFirstAccess,
                                                 password,
                                                 setPassword,
                                                 validFacial,
                                                 setValidFacial,
                                                 nextStep,
                                                 setNextStep,
                                                 reloadPessoa
                                             }) {
    const { exibirAlerta, exibirDialog, handleCloseDialog } = useCommonItems();

    const [validPassword, setValidPassword] = useState(false);
    const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
    const [openResetCredentialsDialog, setOpenResetCredentialsDialog] = useState(false);
    const [openFirstAccessDialog, setOpenFirstAccessDialog] = useState(false);

    const [justBioface, setJustBioface] = useState(false);

    async function handleConfirmPassword() {
        try {
            exibirDialog('Validando senha...');

            const res = await checkUserPassword(selectedPessoa.id, password);

            if (res.data?.message === 'Sucesso') {
                setValidPassword(true);
                setOpenPasswordDialog(false);
                setNextStep(true);
            }
        } catch (error) {
            const msg = error.response?.data?.message;

            if (msg === 'Senha incorreta') {
                exibirAlerta('Ops', 'Senha não correspondente', 'error');
            } else {
                exibirAlerta('Ops', 'Erro ao validar senha', 'error');
            }

            setValidPassword(false);
        } finally {
            handleCloseDialog();
        }
    }

    useEffect(() => {
        setNextStep(validPassword || validFacial);
    }, [validPassword, validFacial, setNextStep]);

    useEffect(() => {
        setNextStep(false);
        setValidPassword(false);
        setPassword(null);
        setValidFacial(false);
        setJustBioface(false);
    }, [selectedPessoa]);

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Paper
                        elevation={2}
                        sx={{
                            p: 3,
                            height: '100%',
                            border: validFacial || validPassword ? '2px solid #1E5139' : '1px solid #e0e0e0'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                            <Fingerprint sx={{ color: '#1E5139' }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                Validação
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                gap: 2,
                            }}
                        >
                            <WebcamCapture
                                biometriaSrc={biometriaSrc}
                                setBiometriaSrc={setBiometriaSrc}
                                isAllowedCapture={isAllowedCapture}
                                setIsAllowedCapture={setIsAllowedCapture}
                                isFirstAccess={isFirstAccess}
                                multiplier={1.5}
                                checkFacial={true}
                                setOpenPasswordDialog={setOpenPasswordDialog}
                                nextStep={validPassword || validFacial}
                            />
                        </Box>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Paper
                        elevation={2}
                        sx={{
                            p: 3,
                            height: '100%',
                            border: validFacial || validPassword ? '2px solid #1E5139' : '1px solid #e0e0e0'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                            <VerifiedUser sx={{ color: '#1E5139' }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                Dados do colaborador
                            </Typography>
                        </Box>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Confirme os dados do colaborador
                        </Typography>

                        {selectedPessoa && (
                            <>
                                <Box
                                    sx={{
                                        display: 'table',
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        border: '1px solid #ddd',
                                        borderRadius: 1,
                                        overflow: 'hidden'
                                    }}
                                >
                                    {[
                                        ['Nome', selectedPessoa.nome || 'Não informado'],
                                        ['Matrícula', selectedPessoa.matricula || 'Não informado'],
                                        ['Departamento', selectedPessoa.departamento?.nome || 'Não informado'],
                                        ['Área', selectedPessoa.area?.nome || 'Não informado'],
                                        ['Grupo', selectedPessoa.grupo?.nome || 'Não informado'],
                                        ['Setor', selectedPessoa.setor?.titulo || 'Não informado'],
                                        ['Data de nascimento', selectedPessoa.dtNascimento || 'Não informado'],
                                        ['Status', selectedPessoa.status ? 'Ativo' : 'Inativo'],
                                    ].map(([label, value]) => (
                                        <Box
                                            key={label}
                                            sx={{ display: 'table-row',
                                                '&:nth-of-type(even)': {
                                                    backgroundColor: '#fafafa',
                                                }
                                            }}
                                        >
                                            <Box sx={{ display: 'table-cell', padding: 1, fontWeight: 'bold', borderBottom: '1px solid #ddd', width: '40%' }}>
                                                {label}
                                            </Box>
                                            <Box sx={{ display: 'table-cell', padding: 1, borderBottom: '1px solid #ddd', width: '60%' }}>
                                                {value}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        mt: 2
                                    }}
                                >
                                    {!isFirstAccess && biometriaSrc ? (
                                        <>
                                            {hasPermission(['admin', 'admin_pessoas', 'update_pessoas']) && (
                                                <Button
                                                    variant='outlined'
                                                    onClick={() => setOpenResetCredentialsDialog(true)}
                                                >
                                                    Resetar Credenciais
                                                </Button>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {hasPermission(['admin', 'admin_pessoas', 'update_pessoas']) && (
                                                <>
                                                    {!biometriaSrc && !isFirstAccess ? (
                                                        <Button
                                                            variant='contained'
                                                            onClick={() => {
                                                                setOpenFirstAccessDialog(true)
                                                                setJustBioface(true);
                                                            }}
                                                            disabled={isAllowedCapture}
                                                        >
                                                            Definir Bioface
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            variant='contained'
                                                            onClick={() => setOpenFirstAccessDialog(true)}
                                                            disabled={isAllowedCapture}
                                                        >
                                                            Definir Primeiro Acesso
                                                        </Button>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </Box>
                            </>
                        )}
                    </Paper>
                </Grid>

                {(validFacial || validPassword) ? (
                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                backgroundColor: '#E8F5E9',
                                border: '1px solid #4CAF50',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1.5,
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <CheckCircleIcon sx={{ color: '#2E7D32', fontSize: 22 }} />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#1B5E20',
                                    fontWeight: 500,
                                    textAlign: 'center',
                                }}
                            >
                                Identidade confirmada. Clique em <strong>"Continuar"</strong> para escolher os EPI's.
                            </Typography>
                        </Paper>
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                backgroundColor: '#FFF8E1',
                                border: '1px solid #FFB300',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1.5,
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <HourglassBottomIcon sx={{ color: '#FB8C00', fontSize: 22 }} />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#E65100',
                                    fontWeight: 500,
                                    textAlign: 'center',
                                }}
                            >
                                Aguardando confirmação de identidade...
                            </Typography>
                        </Paper>
                    </Grid>
                )}
            </Grid>

            {/* Dialog de Senha */}
            <Dialog open={openPasswordDialog}>
                <DialogTitle>Confirmação de identidade</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>Digite a senha do colaborador para confirmar sua identidade</Typography>
                    </DialogContentText>

                    <TextField
                        autoFocus
                        margin="dense"
                        label="Senha"
                        type="password"
                        fullWidth
                        variant="outlined"
                        value={password || ''}
                        onChange={(event) => setPassword(event.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleConfirmPassword();
                            }
                        }}
                        sx={{ mt: 4 }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setOpenPasswordDialog(false);
                            setPassword(null);
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleConfirmPassword}
                        disabled={!password}
                    >
                        Validar
                    </Button>
                </DialogActions>
            </Dialog>

            <ResetCredentials
                open={openResetCredentialsDialog}
                setOpen={setOpenResetCredentialsDialog}
                reloadPessoa={reloadPessoa}
                selectedPessoa={selectedPessoa}
            />

            <FirstAccess
                open={openFirstAccessDialog}
                setOpen={setOpenFirstAccessDialog}
                reloadPessoa={reloadPessoa}
                selectedPessoa={selectedPessoa}
                justBioface={justBioface}
            />
        </>
    );
}